import { render } from "./OrganizationRegistrationForm.vue?vue&type=template&id=19ee3e76&ts=true"
import script from "./OrganizationRegistrationForm.vue?vue&type=script&lang=ts"
export * from "./OrganizationRegistrationForm.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/matthias/Code/uniki/vergabe/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__